@if (status()) {
  <button
    class="relative overflow-hidden w-[54px] py-[3px] h-7 rounded-full flex items-center cursor-pointer outline-none focus:outline-none focus:ring-2 focus-visible:ring-2 ring-offset-2"
    [class]="switchClasses()"
    [disabled]="disabledStatus()"
    (click)="toggle()"
    [attr.aria-checked]="value"
    [attr.aria-labelledby]="ariaLabeledBy()"
    role="switch"
  >
    <div
      class="bg-white rounded-full h-[22px] w-[22px] absolute top-1/2 -translate-y-1/2 transform transition-transform duration-300"
      [ngClass]="{
        'translate-x-1': !value,
        'translate-x-7': value,
      }"
    ></div>
    <div
      class="uppercase text-white font-semibold leading-3 text-[10px] ml-2"
      [class.opacity-0]="!value"
    >
      {{ 'shared.on' | scTranslate | async }}
    </div>
    <div
      class="uppercase text-white font-semibold leading-3 text-[10px] ml-2"
      [class.opacity-0]="value"
    >
      {{ 'shared.off' | scTranslate | async }}
    </div>
  </button>
} @else {
  <button
    class="w-[54px] py-[3px] h-7 rounded-full flex items-center cursor-pointer outline-none focus:outline-none focus:ring-2 focus-visible:ring-2 ring-offset-2"
    [ngClass]="{
      'bg-primaryRed ring-primaryRed': !value,
      'bg-success ring-success': value,
    }"
    [disabled]="disabled"
    (click)="toggle()"
    [attr.aria-checked]="value"
    [attr.aria-labelledby]="ariaLabeledBy()"
    role="switch"
  >
    <div
      class="bg-white rounded-full h-[22px] w-[22px] transform transition-transform absolute duration-300"
      [ngClass]="{
        'translate-x-1': !value,
        'translate-x-7': value,
      }"
    ></div>
    <div class="uppercase text-white font-semibold leading-3 text-[10px] ml-2">
      {{ 'shared.on' | scTranslate | async }}
    </div>
    <div class="uppercase text-white font-semibold leading-3 text-[10px] ml-2">
      {{ 'shared.off' | scTranslate | async }}
    </div>
  </button>
}
